import { showFrequency } from 'contexts/Show/model'

export const Form = {
  name: {
    component: 'FormText',
    label: 'Name',
    defaultValue: '',
    rules: { required: true,  min: 0, max: 100 }
  },
  desc: {
    component: 'FormMarkdown',
    label: 'Description',
    defaultValue: ''
  },
  image: {
    component: 'FormImage',
    label: 'Image',
    defaultValue: '',
    rules: { required: false }
  },
  cardImage: {
    component: 'FormImage',
    label: 'Background Segment Image',
    defaultValue: '',
    rules: { required: false }
  },
  color: {
    component: 'FormColor',
    label: 'Color',
    defaultValue: '#fff'
  },
  backgroundColor: {
    component: 'FormColor',
    label: 'Background Color',
    defaultValue: '#000'
  },
  maxDuration: {
    component: 'FormNumber',
    label: 'Max Duration (s)',
    defaultValue: 3600
  },
  minPoints: {
    component: 'FormNumber',
    label: 'Min Point (s)',
    defaultValue: 10,
    rules: { min: 0, max: 100 }
  },
  maxPoints: {
    component: 'FormNumber',
    label: 'Max Point (s)',
    defaultValue: 100,
    rules: { min: 0, max: 100 }
  },
  cost: {
    component: 'FormCurrency',
    label: 'Cost (income)',
    defaultValue: 1000
  },
  frequency: {
    component: 'FormFrequencySelect',
    label:
      'Frequency',
    defaultValue: showFrequency.weekly
  },
  dayIndex: {
    component: 'FormSelectDayOfWeek',
    label:
      'Day of week',
    defaultValue: 0,
    rules: { min: 0, max: 7 }
  },
  monthIndex: {
    component: 'FormMonthSelect',
    label:
      'Month (if applicable)',
    defaultValue: false,
    rules: { min: 0, max: 11 }
  },
  weekIndex: {
    component: 'FormWeekSelect',
    label:
      'Week of the month (if applicable)',
    defaultValue: false,
    rules: { min: 0, max: 11 }
  },
  entranceVideoUrl: {
    component: 'FormText',
    label: 'Entrance video; Youtube Id (last part of the youtube url)',
    defaultValue: ''
  },
  brandIds: {
    component: 'FormBrandList',
    label: 'Brands',
    defaultValue: []
  },
  refereeIds: {
    component: 'FormWrestlerList',
    label: 'Referees',
    defaultValue: []
  },
  interviewerIds: {
    component: 'FormWrestlerList',
    label: 'Interviewers',
    rules: { minLength: 1 },
    defaultValue: []
  },
  commentatorIds: {
    component: 'FormWrestlerList',
    label: 'Commentators',
    rules: { minLength: 1 },
    defaultValue: []
  },
  authorityIds: {
    component: 'FormWrestlerList',
    label: 'Authority Figures',
    rules: { minLength: 1 },
    defaultValue: []
  }
}

export const RelationForm = {
  brandIds: {
    component: 'FormBrandList',
    label: 'Brands',
    defaultValue: []
  },
  refereeIds: {
    component: 'FormWrestlerList',
    label: 'Referees',
    defaultValue: []
  },
  interviewerIds: {
    component: 'FormWrestlerList',
    label: 'Interviewers',
    rules: { minLength: 1 },
    defaultValue: []
  },
  commentatorIds: {
    component: 'FormWrestlerList',
    label: 'Commentators',
    rules: { minLength: 1 },
    defaultValue: []
  },
  authorityIds: {
    component: 'FormWrestlerList',
    label: 'Authority Figures',
    rules: { minLength: 1 },
    defaultValue: []
  }
}

export const QuickForm = {}

export default Form
